/* @flow */
import { Observable, ReplaySubject } from 'rxjs';
import { ActionsObservable } from 'redux-observable';
import { combineEpics } from 'redux-observable';
import createDebugger from 'debug';
import { fromJS } from 'immutable';

const debug = createDebugger('app:modules:features:epics'); // eslint-disable-line no-unused-vars

import {
  FEATURES_UPDATED,
  SPLIT_SDK_READY,
  SPLIT_SDK_UPDATE,
  SPLIT_SDK_READY_TIMED_OUT
} from './action-types.js';
import { INITIALIZE } from 'modules/app/action-types.js';
import { SplitFactory } from '@splitsoftware/splitio';
import { pathOr } from 'ramda';
import {
  FETCH_SUCCESS as FETCH_PROFILE_SUCCESS,
  UPDATE_SUCCESS as UPDATE_PROFILE_SUCCESS
} from 'modules/profile/action-types.js';

import * as ProfileGetters from 'modules/profile/getters.js';

import { makeSplitClient, makeFlagList } from './utils';

// Since we initialize split in an async way we use a subject to reference it.
// This subject should in practice only emit one single value--the split
// instance.
const flagList = makeFlagList();
const split$ = new ReplaySubject(1);

const wrapSplit = split =>
  Observable.create(obs => {
    split.on(split.SDK_READY, () => obs.next({ type: SPLIT_SDK_READY }));
    split.on(split.SDK_READY_TIMED_OUT, () =>
      obs.next({ type: SPLIT_SDK_READY_TIMED_OUT })
    );
    split.on(split.SDK_UPDATE, () => obs.next({ type: SPLIT_SDK_UPDATE }));

    return () => split.destroy();
  });

/**
 * Initialize our split client instance.
 *
 * NOTE: The distinct call should make sure that even if the profile is fetched
 * multiple times it will not instantiate multiple split instances
 */
const initializeSplitEpic = action$ =>
  action$
    .ofType(FETCH_PROFILE_SUCCESS, UPDATE_PROFILE_SUCCESS)
    .map(pathOr(null, ['payload', 'email']))
    .filter(Boolean) // Make sure we actually get guids
    .distinct() // See NOTE
    .map(makeSplitClient)
    .do(split$) // Initialize split
    .mergeMap(wrapSplit);

const fetchLatestTreatmentsEpic = (action$, store) =>
  action$
    .ofType(SPLIT_SDK_READY, SPLIT_SDK_UPDATE)
    .combineLatest(split$)
    .map(combinedActions => combinedActions[1])
    .map(split => {
      const profile = ProfileGetters.profile(store.getState());
      const x = {
        guid: profile.get('guid'),
        email: profile.get('email'),
        firstName: profile.get('firstName'),
        lastName: profile.get('lastName'),
        enclaveInboxLimit: profile.getIn(['company', 'maxIngestEmailsCount']),
        trialCompany: profile.getIn(['company', 'trialCompany']),
        companyGuid: profile.getIn(['company', 'guid']),
        companyName: profile.getIn(['company', 'name'])
      };
      return split.getTreatmentsWithConfig(flagList, x);
    })
    .map(features => ({
      type: FEATURES_UPDATED,
      payload: features
    }));

export default combineEpics(initializeSplitEpic, fetchLatestTreatmentsEpic);



// WEBPACK FOOTER //
// ./src/app/modules/features/epics.js